<template>
  <div class="c-slider flex flex-col">
    <span
      v-if="title"
      class="pb-2 text-base font-normal leading-5"
      :style="{
        color: themeVars.text,
      }"
      >{{ title }}</span
    >
    <NSlider
      :disabled="disabled"
      :format-tooltip="formatTooltip"
      :max="max"
      :min="min"
      :on-update:value="(value: number) => emit('update:value', value)"
      :placement="placement"
      :step="step"
      :style="{
        '--n-rail-color': themeVars.primary5,
        '--n-rail-color-hover': themeVars.primary5,
      }"
      :value="value"
    />

    <div v-if="helpText || slots.helpText" class="mt-2 text-xs font-normal leading-5">
      <span v-if="helpText">{{ helpText }}</span>
      <slot v-else-if="slots.helpText" name="helpText"></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useSlots } from 'vue'
import { NSlider } from 'naive-ui'
import { type SliderProps } from 'naive-ui'

import useThemeVars from '@lib/composables/useThemeVars'

const emit = defineEmits(['update:value'])

interface Props {
  formatTooltip?: SliderProps['formatTooltip']
  helpText?: string
  max?: SliderProps['max']
  min?: SliderProps['min']
  placement?: SliderProps['placement']
  step: SliderProps['step']
  title?: string
  value?: SliderProps['value']
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  formatTooltip: undefined,
  helpText: '',
  max: 100,
  min: 0,
  placement: 'bottom',
  title: '',
  value: undefined,
  disabled: false,
})

const slots = useSlots()

const themeVars = useThemeVars()
</script>
